import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const buildUpdateContractInsuredAddress = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		addressId,
		entityId,
		input,
		store
	}) {
		const query = gql`
			mutation updateContractInsuredAddress(
				$policyId: String!
				$endorsementId: String
				$addressId: String!
				$entityId: String!
				$input: updateAddressInput!
			) {
				updateContractInsuredAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					addressId: $addressId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, addressId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateContractInsuredAddress, store)
		return {
			status: res?.data?.updateContractInsuredAddress?.status,
			id: res?.data?.updateContractInsuredAddress?.createdStatus?.id
		}
	}
}
const buildUpdateContractInsuredContact = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		contactId,
		entityId,
		input,
		store
	}) {
		const query = gql`
			mutation updateContractInsuredContact(
				$policyId: String!
				$endorsementId: String
				$contactId: String!
				$entityId: String!
				$input: updateContactInput!
			) {
				updateContractInsuredContact(
					policyId: $policyId
					endorsementId: $endorsementId
					contactId: $contactId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, contactId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateContractInsuredContact, store)
		return {
			status: res?.data?.updateContractInsuredContact?.status,
			id: res?.data?.updateContractInsuredContact?.createdStatus?.id
		}
	}
}
const buildUpdateContractInsuredFact = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		factId,
		entityId,
		input,
		store
	}) {
		const query = gql`
			mutation updateContractInsuredFact(
				$policyId: String!
				$endorsementId: String
				$factId: String!
				$entityId: String!
				$input: updateFactInput!
			) {
				updateContractInsuredFact(
					policyId: $policyId
					endorsementId: $endorsementId
					factId: $factId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, factId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateContractInsuredFact, store)
		return {
			status: res?.data?.updateContractInsuredFact?.status,
			id: res?.data?.updateContractInsuredFact?.createdStatus?.id
		}
	}
}
const buildUpdateContractInsuredIdentity = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		identityId,
		entityId,
		input,
		store
	}) {
		const query = gql`
			mutation updateContractInsuredIdentity(
				$policyId: String!
				$endorsementId: String
				$identityId: String!
				$entityId: String!
				$input: updateIdentityInput!
			) {
				updateContractInsuredIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					identityId: $identityId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, identityId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateContractInsuredIdentity, store)
		return {
			status: res?.data?.updateContractInsuredIdentity?.status,
			id: res?.data?.updateContractInsuredIdentity?.createdStatus?.id
		}
	}
}
const buildUpdateContractInsuredIndividual = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation updateContractInsured(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: updateContractIndividualInput
			) {
				updateContractInsured(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					individualInput: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateContractInsured, store)
		return {
			status: res?.data?.updateContractInsured?.status,
			id: res?.data?.updateContractInsured?.createdStatus?.id
		}
	}
}
const buildUpdateContractInsuredCompany = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation updateContractInsured(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: updateContractCompanyInput
			) {
				updateContractInsured(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					companyInput: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateContractInsured, store)
		return {
			status: res?.data?.updateContractInsured?.status,
			id: res?.data?.updateContractInsured?.createdStatus?.id
		}
	}
}
const buildUpdateContractInsuredObject = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation updateContractInsured(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: updateContractObjectInput
			) {
				updateContractInsured(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					objectInput: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateContractInsured, store)
		return {
			status: res?.data?.updateContractInsured?.status,
			id: res?.data?.updateContractInsured?.createdStatus?.id
		}
	}
}

// ***************************** Add **********************************
const buildAddContractInsuredAddress = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation addContractInsuredAddress(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: addressInput!
			) {
				addContractInsuredAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addContractInsuredAddress, store)
		return {
			status: res?.data?.addContractInsuredAddress?.status,
			id: res?.data?.addContractInsuredAddress?.createdStatus?.id
		}
	}
}
const buildAddContractInsuredContact = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation addContractInsuredContact(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: addContactInput!
			) {
				addContractInsuredContact(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addContractInsuredContact, store)
		return {
			status: res?.data?.addContractInsuredContact?.status,
			id: res?.data?.addContractInsuredContact?.createdStatus?.id
		}
	}
}
const buildAddContractInsuredFact = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation addContractInsuredFact(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: addFactInput!
			) {
				addContractInsuredFact(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addContractInsuredFact, store)
		return {
			status: res?.data?.addContractInsuredFact?.status,
			id: res?.data?.addContractInsuredFact?.createdStatus?.id
		}
	}
}
const buildAddContractInsuredIdentity = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation addContractInsuredIdentity(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: addIdentityInput!
			) {
				addContractInsuredIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addContractInsuredIdentity, store)
		return {
			status: res?.data?.addContractInsuredIdentity?.status,
			id: res?.data?.addContractInsuredIdentity?.createdStatus?.id
		}
	}
}

// ***************************** Remove **********************************
const buildRemoveContractInsuredAddress = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		addressId,
		entityId,
		store
	}) {
		const query = gql`
			mutation removeContractInsuredAddress(
				$policyId: String!
				$endorsementId: String
				$addressId: String!
				$entityId: String!
			) {
				removeContractInsuredAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					addressId: $addressId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, addressId, entityId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeContractInsuredAddress, store)
		return {
			status: res?.data?.removeContractInsuredAddress?.status,
			id: res?.data?.removeContractInsuredAddress?.createdStatus?.id
		}
	}
}
const buildRemoveContractInsuredContact = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		contactId,
		entityId,
		store
	}) {
		const query = gql`
			mutation removeContractInsuredContact(
				$policyId: String!
				$endorsementId: String
				$contactId: String!
				$entityId: String!
			) {
				removeContractInsuredContact(
					policyId: $policyId
					endorsementId: $endorsementId
					contactId: $contactId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, contactId, entityId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeContractInsuredContact, store)
		return {
			status: res?.data?.removeContractInsuredContact?.status,
			id: res?.data?.removeContractInsuredContact?.createdStatus?.id
		}
	}
}
const buildRemoveContractInsuredFact = function(errorHandler) {
	return async function({ policyId, endorsementId, factId, entityId, store }) {
		const query = gql`
			mutation removeContractInsuredFact(
				$policyId: String!
				$endorsementId: String
				$factId: String!
				$entityId: String!
			) {
				removeContractInsuredFact(
					policyId: $policyId
					endorsementId: $endorsementId
					factId: $factId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, factId, entityId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeContractInsuredFact, store)
		return {
			status: res?.data?.removeContractInsuredFact?.status,
			id: res?.data?.removeContractInsuredFact?.createdStatus?.id
		}
	}
}
const buildRemoveContractInsuredIdentity = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		identityId,
		entityId,
		store
	}) {
		const query = gql`
			mutation removeContractInsuredIdentity(
				$policyId: String!
				$endorsementId: String
				$identityId: String!
				$entityId: String!
			) {
				removeContractInsuredIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					identityId: $identityId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, identityId, entityId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeContractInsuredIdentity, store)
		return {
			status: res?.data?.removeContractInsuredIdentity?.status,
			id: res?.data?.removeContractInsuredIdentity?.createdStatus?.id
		}
	}
}

// ****************** Remove section **********************
const buildRemoveContractInsured = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, store }) {
		const query = gql`
			mutation removeContractInsured(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
			) {
				removeContractInsured(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeContractInsured, store)
		return {
			status: res?.data?.removeContractInsured?.status,
			id: res?.data?.removeContractInsured?.createdStatus?.id
		}
	}
}

export {
	buildUpdateContractInsuredAddress,
	buildUpdateContractInsuredCompany,
	buildUpdateContractInsuredObject,
	buildUpdateContractInsuredContact,
	buildUpdateContractInsuredFact,
	buildUpdateContractInsuredIdentity,
	buildUpdateContractInsuredIndividual,
	buildAddContractInsuredAddress,
	buildAddContractInsuredContact,
	buildAddContractInsuredFact,
	buildAddContractInsuredIdentity,
	buildRemoveContractInsuredAddress,
	buildRemoveContractInsuredContact,
	buildRemoveContractInsuredFact,
	buildRemoveContractInsuredIdentity,
	buildRemoveContractInsured
}
